module.exports = __webpack_public_path__ + "static/media/gh.77872d15.svg";